import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import Logo from '../../../assets/app-only/images/logo.png';
import './index.scss';

const Brand: React.FC = () => {
  const { theme } = useContext(AuthContext);

  return (
    <a className="auth-brand-link d-flex align-items-center gap-2" href="/">
      <img
        src={require('../../../assets/img/logos/Primary + Name transparent.png.png')}
        alt="CPZone Logo"
        className="auth-brand-logo"
      />
    </a>
  );
};

export default Brand;
